var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStand2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5848 28.0396C44.7193 28.6379 42.8485 30.42 41.2916 33.4341C41.2836 33.4498 41.2755 33.4654 41.2674 33.4811C39.6784 34.2191 38.2309 35.2104 36.9766 36.403C35.7093 35.7247 34.5385 34.9314 33.4866 34.0388C30.2843 37.3889 28.2063 41.8457 27.8712 46.791H32.0448C32.0149 47.1901 31.9998 47.5933 31.9998 48C31.9998 48.5473 32.0272 49.0882 32.0809 49.6214H27.8712C28.2043 54.5379 30.2602 58.9715 33.4307 62.3149C34.5035 61.3973 35.7013 60.5835 37.0001 59.8905C36.9605 59.7636 36.9215 59.6359 36.8832 59.5075C38.0888 60.6724 39.4769 61.6496 41.0005 62.3919C41.0957 62.5913 41.1927 62.7868 41.2916 62.9783C42.8485 65.9924 44.7193 67.7745 46.5848 68.3728V63.9383C47.051 63.9791 47.5229 64 47.9998 64C48.4767 64 48.9489 63.9791 49.4152 63.9382V68.3728C51.2807 67.7745 53.1514 65.9924 54.7084 62.9783C54.8073 62.7867 54.9044 62.5911 54.9996 62.3916C56.5232 61.6491 57.9114 60.6719 59.117 59.5069C59.0786 59.6356 59.0395 59.7635 58.9998 59.8907C60.2986 60.5838 61.4963 61.3976 62.5691 62.3152C65.7397 58.9717 67.7956 54.538 68.1288 49.6214H63.9186C63.9723 49.0882 63.9998 48.5473 63.9998 48C63.9998 47.5933 63.9846 47.1901 63.9548 46.791H68.1288C67.7937 41.8456 65.7156 37.3887 62.5132 34.0385C61.4612 34.9312 60.2903 35.7247 59.0229 36.403C57.7688 35.2105 56.3215 34.2194 54.7327 33.4814C54.7246 33.4656 54.7165 33.4498 54.7084 33.4341C53.1514 30.42 51.2807 28.6379 49.4152 28.0396V32.0618C48.9489 32.0209 48.4767 32 47.9998 32C47.5229 32 47.051 32.0209 46.5848 32.0617V28.0396ZM48 24.9816C35.2802 24.9816 24.9929 35.393 24.9929 48.2062C24.9929 61.0194 35.2802 71.4308 48 71.4308C60.7198 71.4308 71.0071 61.0194 71.0071 48.2062C71.0071 35.393 60.7198 24.9816 48 24.9816ZM35.5357 64.2442C36.2824 63.6332 37.1013 63.0754 37.9823 62.58C38.232 63.1694 38.4972 63.7359 38.7768 64.2773C39.3198 65.3285 39.9322 66.3096 40.6083 67.1878C38.7706 66.456 37.0642 65.4594 35.5357 64.2442ZM57.2232 64.2773C57.5028 63.7359 57.7679 63.1695 58.0176 62.5802C58.8985 63.0756 59.7174 63.6334 60.4641 64.2444C58.9356 65.4595 57.2293 66.4561 55.3917 67.1878C56.0678 66.3097 56.6802 65.3285 57.2232 64.2773ZM38.7768 32.1351C38.5108 32.6502 38.2578 33.188 38.0188 33.7466C37.15 33.2607 36.3411 32.7141 35.6019 32.1158C37.1135 30.9243 38.7971 29.9458 40.6083 29.2245C39.9322 30.1027 39.3198 31.0839 38.7768 32.1351ZM55.3917 29.2245C57.2028 29.9458 58.8863 30.9242 60.3979 32.1156C59.6587 32.7139 58.8499 33.2604 57.9811 33.7464C57.7421 33.1878 57.4892 32.6501 57.2232 32.1351C56.6802 31.0839 56.0678 30.1027 55.3917 29.2245Z",
    fill: "#008CB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 33.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#008CB7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 53.5H50.5M42 48H54M42 42.5H54",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_1380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStand2);
export default __webpack_public_path__ + "static/media/stand2.fb9ab1319f7d9e518c221b63361687c3.svg";
export { ForwardRef as ReactComponent };